import { env } from "@saas/config/shared/env/env";

import { dayjs } from "../../dayjs/dayjs";
import { FetchError } from "../fetch-error/fetch-error";

import * as uuid from "uuid";

const isTest = process.env["NODE_ENV"] === "test";
const isStorybook = process.env["STORYBOOK"] === "true";

const BASE_URL = typeof window === "undefined" ? env.APP_URL : "";

export const fetchJson = async <JSONDataType = unknown>(
  input: RequestInfo,
  init?: RequestInit
): Promise<JSONDataType> => {
  const url =
    isTest || isStorybook ? "https://localhost.test" + input : BASE_URL + input;

  const response = await fetch(url, {
    ...init,
    headers: {
      ...init?.headers,
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Request-ID": uuid.v4(),
      "X-Timezone-Offset": dayjs().format("Z"),
    },
  });

  // if the server replies, there's always some data in json
  // if there's a network error, it will throw at the previous line
  const data = await response.json();

  if (!response.ok) {
    throw new FetchError({
      message: data.message ?? response.statusText,
      response,
      payload: init?.body,
      data,
    });
  }

  return data;
};

export default fetchJson;
